import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselComponent } from './carousel.component';
import { CarouselDirective } from './carousel.directive';
import { ButtonModule } from '../button/button.module';
import { MediaModule } from '@challenger6/vm-pattern-library/media';
import { CarouselSlideComponent } from './carousel-slide/carousel-slide.component';
import { CarouselNavigationComponent } from './carousel-navigation/carousel-navigation.component';
import { ModalModule } from '@challenger6/vm-pattern-library/modal';
import { MarkdownModule } from 'ngx-markdown';
import { LinkModule } from '@challenger6/vm-pattern-library/link';
import { ConfirmationModule } from '../confirmation/confirmation.module';

const components = [CarouselComponent, CarouselSlideComponent, CarouselDirective, CarouselNavigationComponent];
@NgModule({
  declarations: [...components],
  imports: [CommonModule, ButtonModule, MediaModule, ModalModule, MarkdownModule, LinkModule, ConfirmationModule],
  exports: [...components],
})
export class CarouselModule {}
